import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LoanFormType } from 'views/orders/loans/types';

import { OptionalChoiceForm } from '../optional-choice-form';

type Props = {
  control: Control<LoanFormType, object>
  isDataLoading: boolean,
  onSave: (e?: React.BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
}

export const AssumptionForm: FC<Props> = ({ control, isDataLoading, onSave }) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="transfer_assumption"
      render={({ field }) => (
        <OptionalChoiceForm
          onBlur={() => { onSave(); }}
          title={t('loanDisclosures:assumption')}
          description={t('loanDisclosures:assumption-subtitle')}
          value={field.value}
          options={[
            {
              label: t('loanDisclosures:assumption-option-1'),
              disabled: isDataLoading,
              value: true
            },
            {
              label: t('loanDisclosures:assumption-option-2'),
              disabled: isDataLoading,
              value: false
            }
          ]}
          onChange={(value) => field.onChange(value)}
          onSave={() => { onSave(); }}
        />
      )}
    />
  );
};
